import { render, staticRenderFns } from "./worklist_header.vue?vue&type=template&id=81e60148&scoped=true"
import script from "./worklist_header.vue?vue&type=script&lang=js"
export * from "./worklist_header.vue?vue&type=script&lang=js"
import style0 from "./worklist_header.vue?vue&type=style&index=0&id=81e60148&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e60148",
  null
  
)

export default component.exports